var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleBgW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.364,
    height: 101.574,
    viewBox: "0 0 126.364 101.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M181.779,2244.186c-4.211,14.318-18.342,31.388-61.754,31.388S62.481,2258.5,58.27,2244.185c-4.656-15.832,2.859-30.565,11.308-39.129a16.342,16.342,0,0,1-5.856-5.217c-3.677-6.532-.723-15.167,6.6-19.287s16.235-2.166,19.911,4.366a15.311,15.311,0,0,1,1.427,6.526c3.819-1.377,7.745-2.5,11.82-3.581,5.639-1.5,9.258-7.015,11.42-10.308.328-.5.626-.952.892-1.337h0a5.157,5.157,0,0,1,4.236-2.218h0a5.158,5.158,0,0,1,4.235,2.219c.266.384.564.837.893,1.339,2.162,3.292,5.781,8.8,11.418,10.3,3.878,1.033,7.622,2.1,11.267,3.383a15.112,15.112,0,0,1,1.424-6.328c3.677-6.532,12.591-8.487,19.911-4.366s10.274,12.755,6.6,19.287a16.021,16.021,0,0,1-5.509,5.009C178.8,2213.38,186.475,2228.224,181.779,2244.186Z",
    transform: "translate(-56.843 -2174)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBgW);
export default __webpack_public_path__ + "static/media/titleBg-w.bc7f40fe16edf92ae2386f531d010e5d.svg";
export { ForwardRef as ReactComponent };